export const actionTypes = {
  REQUEST_START: 'MY_TAXES.PDFINFO.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'MY_TAXES.PDFINFO.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'MY_TAXES.PDFINFO.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MY_TAXES.PDFINFO.REQUEST_FAILURE',
};

export function startRequestToGetPdfInfo(payload) {
  return {
    type: actionTypes.REQUEST_START,
    payload,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
